import React from "react";
import { Helmet } from "react-helmet-async";
import loadable from "@loadable/component";
import withReducer from "../../../components/shared/with-reducer";
import withLayout from "../../../components/desktop/layout/component";
const MyChallans = loadable(() => import("../../../components/desktop/my-challans"), {ssr: true});
import injectableReducers from "./injectable";

const mapStateToProps = () => ({});

const MyChallansContainer = () => {
    return (
        <React.Fragment>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,NOFOLLOW" />
            </Helmet>
            <MyChallans />
        </React.Fragment>
    );
};

export default withReducer(injectableReducers)(mapStateToProps, dispatch => ({ dispatch }))(
    withLayout(
        MyChallansContainer,
        true,
        false,
        false,
        false
    )
);
